import { Pipe, PipeTransform } from '@angular/core';
// may be we should use https://www.npmjs.com/package/safe-pipe instead?

@Pipe({
  name: 'monthName'
})
export class MonthNamePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    var monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December' ];
    return monthNames[value - 1];
  }

}
